// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { createArea, deleteArea, getAreaApi, updateArea } from '../../api/AreaApi'; // Adjust the path as needed
import {
    getAreaSuccess,
    getAreaFailure,
    createAreaSuccess,
    createAreaFailure,
    updateAreaSuccess,
    updateAreaFailure,
    deleteAreaSuccess,
    deleteAreaFailure,
} from './actions';

// Saga to handle fetching Areas
function* fetchAreaSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getAreaApi, action.payload);
        yield put(getAreaSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getAreaFailure(errorMessage));
    }
}

// // Saga to handle creating a Area
function* createAreaSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createArea, action.payload);
        yield put(createAreaSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createAreaFailure(errorMessage));
    }
}

// // Saga to handle updating a Area
function* updateAreaSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateArea, action.payload.data, action.payload.id);
        yield put(updateAreaSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateAreaFailure(errorMessage));
    }
}

// // Saga to handle updating a Area
function* deleteAreaSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteArea, action.payload.id);
        yield put(deleteAreaSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteAreaFailure(errorMessage));
    }
}

export default function* AreaSaga() {
    yield takeEvery('GET_AREA_TYPE_REQUEST', fetchAreaSaga);
    yield takeEvery('CREATE_AREA_TYPE_REQUEST', createAreaSaga);
    yield takeEvery('UPDATE_AREA_TYPE_REQUEST', updateAreaSaga);
    yield takeEvery('DELETE_AREA_TYPE_REQUEST', deleteAreaSaga);
}
